export function trackV2({ category, page, action, element, properties = {} }) {
  try {
    window.Strava.ExternalAnalytics.trackV2({
      category,
      page,
      action,
      element,
      properties
    });
  } catch (e) {
    console.error(
      `Could not execute Strava.ExternalAnalytics.trackV2 event with the category:action ${category}:${action}`,
      e
    );
  }
}

export default {
  trackV2
};
